import { Injectable } from '@angular/core';
import { MaintenanceData } from '@core/interfaces/maintenances/index';
import { CompanyToCompare, MaintenancePerAverageTime, MaintenancePerRating, MaintenancePerSituation, MaintenancePerVolume, ResponseDeadline, SolutionDeadline } from '../interface';

@Injectable({
  providedIn: 'root'
})
export class DataTableMapperService {

  constructor() { }

  public convertMaintenanceDataToDataTable(maintenanceData: MaintenanceData): CompanyToCompare {
    return {
      companyId: maintenanceData.companyId,
      companyName: maintenanceData.name,
      table: {
        maintenancePerSituation: this.getMaintenancePerSituationData(maintenanceData),
        maintenancePerAverageTime: this.getMaintenancePerAverageTimeData(maintenanceData),
        maintenancePerVolume: this.getMaintenancePerVolumeData(maintenanceData),
        ratings: this.getRatingsData(maintenanceData),
        responseDeadline: this.getResponseDeadlineData(maintenanceData),
        solutionDeadline: this.getSolutionDeadLineData(maintenanceData)
      }
    };
  }

  private getMaintenancePerSituationData(maintenanceData: MaintenanceData): MaintenancePerSituation {
    return {
      total: maintenanceData.totalMaintenance,
      requestedItems: maintenanceData.status.requested,
      onNegotiationItems: maintenanceData.status.onNegotiation,
      pendingItems: maintenanceData.status.pending,
      scheduledItems: maintenanceData.status.scheduled,
      inProgressItems: maintenanceData.status.inProgress,
      doneItems: maintenanceData.status.done,
      reportedItems: maintenanceData.status.reported,
      canceledItems: maintenanceData.status.canceled
    };
  }

  private getMaintenancePerAverageTimeData(maintenanceData: MaintenanceData): MaintenancePerAverageTime {
    return {
      pending: maintenanceData.statusInterval.pending,
      requested: maintenanceData.statusInterval.requested,
      onNegotiation: maintenanceData.statusInterval.onNegotiation,
      scheduled: maintenanceData.statusInterval.scheduled,
      inProgress: maintenanceData.statusInterval.inProgress,
      reported: maintenanceData.statusInterval.reported
    };
  }

  private getMaintenancePerVolumeData(maintenanceData: MaintenanceData): MaintenancePerVolume {
    return {
      acceptedTotal: maintenanceData.volumeCount.acceptedCount.value,
      acceptedPercentage: maintenanceData.volumeCount.acceptedCount.percent,
      refusedTotal: maintenanceData.volumeCount.refusedCount.value,
      refusedPercentage: maintenanceData.volumeCount.refusedCount.percent,
      doneTotal: maintenanceData.volumeCount.completedCount.value,
      donePercentage: maintenanceData.volumeCount.completedCount.percent,
      notDoneTotal: maintenanceData.volumeCount.incompleteCount.value,
      notDonePercentage: maintenanceData.volumeCount.incompleteCount.percent
    };
  }

  private getRatingsData(maintenanceData: MaintenanceData): MaintenancePerRating {
    return {
      ratingsTotal: maintenanceData.ratingsCount.totalCount,
      negative: maintenanceData.ratingsCount.negativeCount,
      positive: maintenanceData.ratingsCount.positiveCount,
      totalAverage: maintenanceData.ratingsCount.averageRating
    };
  }

  private getResponseDeadlineData(maintenanceData: MaintenanceData): ResponseDeadline {
    return {
      inDeadline: maintenanceData.averageDeadlines.fistVisitOnTimeCount,
      timeAverageWithDeadline: maintenanceData.averageDeadlines.averageResponseTimeInDays,
      timeAverageTotal: maintenanceData.statusInterval.responseAverage,
      outOfDeadline: maintenanceData.averageDeadlines.fistVisitOutTimeCount,
      inDeadLinePercentage: maintenanceData.averageDeadlines.responseOnTimePercentage
    };
  }

  private getSolutionDeadLineData(maintenanceData: MaintenanceData): SolutionDeadline {
    return {
      inDeadline: maintenanceData.averageDeadlines.closedOnTimeCount,
      timeAverageWithDeadline: maintenanceData.averageDeadlines.averageCloseTimeInDays,
      timeAverageTotal: maintenanceData.statusInterval.solutionAverage,
      outOfDeadline: maintenanceData.averageDeadlines.closedOutTimeCount,
      inDeadLinePercentage: maintenanceData.averageDeadlines.closedOnTimePercentage,
    };
  }
}
